import React, { useEffect } from 'react';
import { AccountGroupsVM } from './account-groups.viewmodel';
import AccountGroupsList from './_account-groups-list/account-groups-list';
import { moduleHost } from '../../infrastructure/components/root-module-host';
import { AccountGroupsContext, connectAccountGroupsVM } from './account-groups.context';

interface IProps {
    vm: AccountGroupsVM;
}

const AccountGroupsContainer = ({ vm }: IProps) => {
    useEffect(() => {
        return () => {
            vm.willUnmount();
        };
    });

    return <AccountGroupsList vm={vm} />;
};

const AccountGroupsConnected = connectAccountGroupsVM<IProps>(AccountGroupsContainer, vm => ({ vm: vm }));

export const AccountGroups = moduleHost(AccountGroupsVM, AccountGroupsContext, AccountGroupsConnected);
